import React from 'react';
var EmptyPlaceholderComponent = function EmptyPlaceholderComponent() {
  return /*#__PURE__*/React.createElement("div", {
    className: "no-data"
  }, " ", __('No rows found'));
};
export default EmptyPlaceholderComponent;